// ../hooks/DataFetching/useFetchPositions.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchPositions = () => {
    const [positions, setPositions] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;
    
    useEffect(() => {
        const populatePositionsData = async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/positions`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setPositions(data);
                    setLoading(false);
                } else {
                    console.error('Failed to fetch positions:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching positions:', error.message);
            }
        };
        populatePositionsData();
    }, [getAccessTokenSilently]);

    return { positions, loading };
};
